import {Component, Input, Inject, OnInit} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {passwordMatchValidator} from "../form-validators";

export namespace EmailPasswordLinkForm {
  export const FIELD_EMAIL = "email"
  export const FIELD_PASSWORD = "password"
  export const FIELD_PASSWORD_CONFIRM = "confirmPassword"
}

@Component({
  selector: 'app-email-password-link-form',
  templateUrl: './email-password-link-form.component.html'
})
export class EmailPasswordLinkFormComponent implements OnInit {
  @Input() submitting = false

  EmailPasswordLinkForm = EmailPasswordLinkForm

  passwordMinLength = 6
  form = new FormGroup({
    [EmailPasswordLinkForm.FIELD_EMAIL]: new FormControl(null, [Validators.required, Validators.email]),
    [EmailPasswordLinkForm.FIELD_PASSWORD]: new FormControl(null, [Validators.required, Validators.minLength(this.passwordMinLength)]),
    [EmailPasswordLinkForm.FIELD_PASSWORD_CONFIRM]: new FormControl(null, [Validators.required]),
  }, {
    validators: passwordMatchValidator(
      EmailPasswordLinkForm.FIELD_PASSWORD,
      EmailPasswordLinkForm.FIELD_PASSWORD_CONFIRM
    )
  })

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { initialEmail?: string },
    private readonly dialogRef: MatDialogRef<EmailPasswordLinkFormComponent>
  ) {}

  ngOnInit() {
    const initialEmail = this.data?.initialEmail
    if (initialEmail) this.form.patchValue({email: initialEmail})
  }

  onSubmit() {
    if (this.form.invalid) return
    const email = this.form.value[EmailPasswordLinkForm.FIELD_EMAIL] as string
    const password = this.form.value[EmailPasswordLinkForm.FIELD_PASSWORD] as string
    this.dialogRef.close({email, password})
  }

  onCancel() {
    this.dialogRef.close()
  }
}
